"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var Line_1 = __importDefault(require("./Line"));
var Speech = function (props) {
    var Speaker = function (speaker) {
        if (!speaker) {
            return;
        }
        var label = props.getPersonLabel(speaker) || "stage direction";
        return (React.createElement("a", { title: label, className: "speaker line" }, speaker));
    };
    var selected_speech = props.selected_line >= props.content.first_line &&
        props.selected_line < props.content.first_line + props.content.text.length;
    var speech_class = "speech" + (selected_speech ? " selected_speech" : "");
    return (React.createElement("div", { key: props.ident, className: speech_class },
        Speaker(props.content.speaker),
        props.content.text.map(function (text, index) {
            var line_number = props.content.first_line + index;
            return (React.createElement(Line_1["default"], { key: line_number, line_number: line_number, scroll_position_map: props.scroll_position_map, text: text }));
        })));
};
exports["default"] = Speech;
